<template>
  <v-app id="inspire">
    <Sidebar class="d-print-none" v-if="!isLoginPage" />
    <Header class="d-print-none" v-if="!isLoginPage" />
    <v-main id="mainWrapper">
      <message-component class="d-print-none"></message-component>
      <router-view :key="$route.fullPath"></router-view>
    </v-main>
    <small v-if="env != 'production'">{{ title }}:{{ env }}:{{ baseUrl }}</small>
  </v-app>
</template>

<script>
import { config } from "@/config";
import { mapActions } from "vuex";
import MessageComponent from "@/components/common/MessageComponent.vue";
import layouts from "@/components/layout/";
import setupInterceptor from "./config/interceptorsConfig.js";

export default {
  components: {
    ...layouts,
    MessageComponent
  },
  props: {
    source: String
  },
  data: () => ({
    headerLoaded: false,
    dialog: false,
    env: process.env.NODE_ENV,
    baseUrl: config.BASE_URL,
    title: process.env.VUE_APP_TITLE
  }),
  computed: {
    isLoginPage() {
      console.log(this.$route)
      return this.$route.name === "Login";
    }
  },
  methods: {
    ...mapActions("navigation", ["appLoading"]),
    loadedCenters(centers) {
      console.log(centers);
      this.headerLoaded = true
    }
  },
  created: function () {
    setupInterceptor(this.$store, this.$router);
  }
};
</script>

<style scoped>
#mainWrapper {
  background-color: #f8f8f8;
}
</style>
